var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-dialog v-dialog--active v-dialog--persistent v-dialog--fullscreen",staticStyle:{"z-index":"222","background":"white"}},[_c('RequestViewerForPrint',{attrs:{"print":true,"request-id":_vm.request_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }